export default async function ({ app, store }) {
    app.i18n.beforeLanguageSwitch = async (oldLocale, newLocale) => {
        if (process.client) {
            window.location.reload();
        } else {
            await store.dispatch('getLocalizeData', newLocale)
        }
    }
}
